import { BusinessFormType } from 'model/business-enums';

export class FormSettings {
  formType: BusinessFormType = null;
}
